import { render } from "./RichEditor.vue?vue&type=template&id=5bd0a037&scoped=true"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"

import "./RichEditor.vue?vue&type=style&index=0&id=5bd0a037&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd0a037"]])

export default __exports__